import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import SurveyTransferMappingItem from '../../../Domain/SurveyTransferMappingItem';
import SurveyTransferMappingService from '../../../Services/SurveyTransferMappingService';

class SurveyTransferMappingWindowDescription extends React.Component
{
  static titleForCreate = 'Add New Survey Transfer Mapping';
  static titleForEdit = 'Edit Survey Transfer Mapping';
  static ComponentName = 'SurveyTransferMapping';
  static itemType = SurveyTransferMappingItem;

  static messageOnSuccess = 'Survey transfer mapping has been created.';

  // Called when the wizard's Save/Finish is clicked. Persists the mapping via the
  // SurveyTransferMapping microservice.
  static serviceFunction = (edited) => SurveyTransferMappingService.CreateSurveyTransferMapping(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Client & Systems',
      fields: [
        {
          // Existing reusable client dropdown component (InputTypesEnum.ClientSelect).
          fieldName: 'ClientId',
          label: 'Client',
          className: 'col-12',
          type: InputTypesEnum.ClientSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          // Hardcoded for now: PrismIntl (TpInstanceId = 11). TextReadOnly already
          // makes the input non-editable while still showing the value. Do NOT set
          // `disabled` - a disabled field renders an empty placeholder instead of the
          // value. The actual id is carried on the edited item (SourceSystemTpInstanceId).
          fieldName: 'SourceSystemName',
          label: 'Source System',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
        },
        {
          // Hardcoded for now: Apollo (TpInstanceId = 1). See the note above about not
          // using `disabled`. The actual id is carried on the edited item
          // (TargetSystemTpInstanceId).
          fieldName: 'TargetSystemName',
          label: 'Target System',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
        },
      ],
    },
    {
      label: 'Surveys',
      fields: [
        {
          // Surveys for the selected client in the SOURCE system (PrismIntl, id 11).
          fieldName: 'SourceTpSurveyId',
          label: 'Source Survey',
          className: 'col-12',
          type: InputTypesEnum.TpSurveyByClientAndInstanceSelect,
          idFilterArray: [
            { filterName: 'ClientId', valueName: 'ClientId' },
            { filterName: 'TpInstanceId', valueName: 'SourceSystemTpInstanceId' },
          ],
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          // Surveys for the selected client in the TARGET system (Apollo, id 1).
          fieldName: 'TargetTpSurveyId',
          label: 'Target Survey',
          className: 'col-12',
          type: InputTypesEnum.TpSurveyByClientAndInstanceSelect,
          idFilterArray: [
            { filterName: 'ClientId', valueName: 'ClientId' },
            { filterName: 'TpInstanceId', valueName: 'TargetSystemTpInstanceId' },
          ],
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];
}

export default SurveyTransferMappingWindowDescription;
